import React from 'react'
import { Box } from '@material-ui/core'

export enum IconSize {
  Small = 18,
  Medium = 24,
}

const sizeMap = {
  small: { wrapper: 24, icon: IconSize.Small },
  medium: { wrapper: 30, icon: IconSize.Medium },
}

type Props = {
  component: React.ElementType
  size?: keyof typeof sizeMap
}

/**
 * react-feather icons aren't rectangular, causing icon buttons to not be circular.
 * This component wraps them with a rectangular div to fix that.
 */
export function Icon({ component, size }: Props): React.ReactElement {
  const Component = component

  const sizes = sizeMap[size ?? 'medium']

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={sizes.wrapper}
      height={sizes.wrapper}
      overflow="hidden"
    >
      <Component size={sizes.icon} />
    </Box>
  )
}
